import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  multFieldLine: {
    display: "flex",
    alignItems: "center",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  tooltip: {
    marginLeft: 10,
    color: theme.palette.text.secondary,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },

  content: {
    padding: 0,
  },

  background: {
    backgroundColor: theme.palette.background100,
  },

  textField: {
    borderRadius: "12px",
    height: "52px",
    justify: "Space-between",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
    },
    marginBottom: 24,
  },
  avatarWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginBottom: 16,
  },
  avatarPreview: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    objectFit: "cover",
  },
  avatarPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    backgroundColor: theme.palette.neutral200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.neutral400,
    fontSize: 32,
  },
  photoDropzone: {
    width: "100%",
    border: "1px dashed " + theme.palette.neutral300,
    borderRadius: theme.radius.radius300,
    minHeight: 132,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 10,
    background: theme.palette.background200,
    position: "relative",
    transition: "border-color 120ms ease, background-color 120ms ease",
    "&:hover": {
      borderColor: theme.palette.primary100,
      background: theme.palette.background300,
    },
  },
  photoIcon: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.palette.background100,
    color: theme.palette.primary200,
  },
  photoText: {
    fontSize: 13,
    color: theme.palette.primary200,
    marginTop: 8,
    textAlign: "center",
    cursor: "pointer",
  },
  photoLabel: {
    fontSize: 15,
    fontWeight: 500,
    horizontalAlign: "center",
    color: theme.palette.primary200,
    textAlign: "center",
    marginTop: theme.spacing(1),
    cursor: "pointer",
  },
  photoImage: {
    width: "100%",
    height: 132,
    objectFit: "cover",
    borderRadius: 12,
  },
  photoCentered: {
    width: 56,
    height: 56,
    objectFit: "cover",
    borderRadius: "50%",
  },
  photoRemoveButton: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    backgroundColor: theme.palette.background100,
    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
    zIndex: 10,
    cursor: "pointer",
    "&:hover": {
      background: theme.palette.background200,
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}))

export default useStyles
